import { useState, useEffect } from "react";
import { Button } from "@heroui/react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import { useTranslation } from "react-i18next";

export default function OnboardingSuccessful() {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(true);

  // Stop confetti after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4">
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          recycle={false}
          numberOfPieces={200}
          gravity={0.3}
        />
      )}

      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="h-24 w-24 rounded-full bg-success/15 flex items-center justify-center">
            <CheckCircle2 className="h-14 w-14 text-success" />
          </div>
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">
            {t("onboarding.successTitle")}
          </h1>
          <p className="text-lg text-default-600">
            {t("onboarding.successBody")}
          </p>
        </div>
        <Button
          color="primary"
          fullWidth
          size="lg"
          onPress={() => navigate("/dashboard")}
          endContent={<ArrowRight className="h-5 w-5" />}
        >
          {t("onboarding.goToDashboard")}
        </Button>
      </div>
    </div>
  );
}
